import type { NextPage } from "next";

import FavouriteLocation from "../../../../components/account/favouriteLocation";
import Header from "../../../../components/layout/Header";
import AccountMenu from "../../../../components/ui/list/AccountMenu";
import classes from "../account.module.scss";

const AccountFavouriteLocation: NextPage = () => {
  return (
    <Header
      title="EatSalad - Favorite Location"
      description="Salade sur mesure à emporter et en livraison | Eat Salad"
    >
      <div className={classes.container}>
        <div className={classes.accountMenuContainer}>
          <AccountMenu />
        </div>
        <div className={classes.accountDetailContainer}>
          <FavouriteLocation />
        </div>
      </div>
    </Header>
  );
};

export default AccountFavouriteLocation;
